import { useMutation, UseMutationResult, useQuery, UseQueryResult } from '@tanstack/react-query';
import { StructureStatesResponse, StatesWithCountryResponse, ZonesResponse, RegionSuburbsResponse } from '../@types';
import { StatesKey, StatesWithCountryKey, ZonesKey } from '../@types/address.type';
import { getStates, getStateWithCountryData, getSuburbsByPostcode, getZones } from '../api/geosocial';

export const useGetStates = (): UseQueryResult<StructureStatesResponse[]> => {
  return useQuery({
    queryKey: [StatesKey],
    queryFn: () => getStates(),
    staleTime: 5 * 60 * 60 * 1000
  });
};

export const useGetStateWithCountryData = (stateId: number): UseQueryResult<StatesWithCountryResponse> => {
  return useQuery({
    queryKey: [StatesWithCountryKey, stateId],
    queryFn: () => getStateWithCountryData(stateId)
  });
};

export const useGetZones = (): UseQueryResult<ZonesResponse[]> => {
  return useQuery({
    queryKey: [ZonesKey],
    queryFn: () => getZones()
  });
};

export const useGetSuburbsByPostcode = (): UseMutationResult<Array<RegionSuburbsResponse>> => {
  return useMutation({
    mutationFn: async (data: any) => {
      return await getSuburbsByPostcode(data);
    }
  });
};